<template>
  <div
    v-if="message"
    class="option-price-update-hint"
    :class="{ tooltip: !isMobile }"
  >
    <div
      class="tooltip__item option-price-update-hint__icon"
      tabindex="0"
      aria-label="Подсказка об изменении цены"
      @click="onIconClick"
    >
      <svg
        width="20"
        height="20"
        viewBox="0 0 28 28"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M14 24C19.5228 24 24 19.5228 24 14C24 8.47715 19.5228 4 14 4C8.47715 4 4 8.47715 4 14C4 19.5228 8.47715 24 14 24Z"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M11.0901 11C11.3252 10.3317 11.7892 9.7681 12.4 9.40912C13.0108 9.05015 13.729 8.91893 14.4273 9.0387C15.1255 9.15848 15.7589 9.52151 16.2152 10.0635C16.6714 10.6055 16.9211 11.2915 16.9201 12C16.9201 14 13.9201 15 13.9201 15"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M14 19H14.01"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </div>
    <div
      v-if="!isMobile"
      class="tooltip__hover"
    >
      {{ message }}
    </div>

    <Teleport to="body">
      <VCupertino
        v-if="isPopupOpen"
        id="option-price-update-hint"
        :is-show="isPopupOpen"
        :drawer-options="{
          cssClass: 'cupertino-modal option-price-update-hint-popup',
          modal: false,
        }"
        @backdropTap="closePopup"
        @didDismiss="closePopup"
      >
        <div class="option-price-update-hint__popup">
          <div class="option-price-update-hint__popup-message h5">
            {{ message }}
          </div>
        </div>
      </VCupertino>
    </Teleport>
  </div>
</template>

<script lang="ts" setup>
import { computed, ref } from 'vue';
import VCupertino from '~/components/widget/VCupertino.vue';

const props = defineProps({
  message: {
    type: String,
    default: ''
  }
});

const $viewport = useViewport();
const isPopupOpen = ref(false);

const isMobile = computed(() => $viewport.isLessThan('md'));

const onIconClick = () => {
  if (!isMobile.value || !props.message) {
    return;
  }
  isPopupOpen.value = true;
};

const closePopup = () => {
  isPopupOpen.value = false;
};
</script>

<style scoped lang="scss">
.option-price-update-hint {
  position: relative;
  display: flex;
  align-items: center;
  flex-shrink: 0;

  &:not(.tooltip) .option-price-update-hint__icon {
    cursor: pointer;
  }

  &.tooltip {
    &:hover .tooltip__hover,
    &:focus-within .tooltip__hover {
      display: block;
    }
  }
}

.option-price-update-hint__icon {
  display: flex;
  align-items: center;
  justify-content: center;
  color: #ED908C;
  line-height: 0;
  outline: none;

  svg {
    display: block;
  }
}

// Как у промо-тега в products/Head.vue
.option-price-update-hint .tooltip__hover {
  top: 100%;
  right: 10px;
  left: auto;
  bottom: initial;
  width: max-content;
  max-width: 320px;
  border-radius: 15px 0 15px 15px;
  transform: translateY(10px);
  z-index: 20;
  background: #F4F3F1;
  box-shadow: none;

  &::after {
    content: "";
    position: absolute;
    top: auto;
    left: auto;
    right: 0;
    bottom: 100%;
    width: 0;
    height: 0;
    border: 10px solid transparent;
    border-right: 15px solid #F4F3F1;
    border-left-width: 0;
    transform: translateY(10px);
    z-index: -1;
    pointer-events: none;
    filter: none;
  }
}

.option-price-update-hint__popup {
  padding: 24px 72px 96px 16px;
}

.option-price-update-hint__popup-message {
  color: #000;
}
</style>
